module.exports = __webpack_public_path__ + "static/media/close.a587fa10.svg";